export const EXPERT_CUSTOMER_NAME_PREFIX = '_SMART_EXPERT_TEMP_';
